/*
 * Copyright (c) 2022-2023. Haodong JU
 */

import IKDataEntity from '@/plugins/EntityFrameWork/IKDataEntity'
import hillo from 'hillo'
import i18n from '@/i18n'

const entity = {
  id: {
    type: IKDataEntity.Types.Integer,
    displayName: 'id',
    form: false
  },
  name: {},
  currentAmount: {
    displayName: 'CashAmount'
  },
  checkDetail: {
    displayName: 'detail',
    type: IKDataEntity.Types.Integer,
    form: false,
    tableConfig: {
      overwrite: true
    }
  }
}
const config = {
  load: async function () {
    return (await hillo.get('CashBoxController.php?op=getCashBoxList', {}))
      .content
  },
  add: async function (item) {
    return (await hillo.post('CashBoxController.php?op=createCashBox', {
      ...item
    }))
  },
  edit: async function (item) {
    return (await hillo.post('CashBoxController.php?op=updateCashBox', {
      ...item
    }))
  },
  remove: async function (id) {
    return (await hillo.post('CashBoxController.php?op=deleteCashBox', {
      id
    }))
  }
}

export default IKDataEntity.ModelFactory(entity, config)

export async function getBoxDetailCashList (id, dateRange) {
  const [fromDate, toDate] = dateRange
  return (await hillo.get('Complex.php?op=getCashInOutDetail', {
    fromDate,
    toDate,
    cashBoxId: id
  })).content.map(it => {
    if (it.cashAccountNote.toLowerCase() === 'umsatz' || it.cashAccountNote.toLowerCase() === 'trinkgeld') {
      it.cashInCome = i18n.t('OperatingIncome')
    } else {
      it.cashInCome = i18n.t('NonOperatingIncome')
    }
    if (!it.name) {
      if (it.payLogAmount >= 0) {
        it.name = i18n.t('Revenue')
      } else {
        it.name = i18n.t('Expenditure')
      }
    }
    return it
  })
}
